module.exports = __webpack_public_path__ + "static/media/fancy_2_top.a84db9cb.svg";